import { isReactClass } from './isReactClass';
/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isDynamicSetter(obj) {
  return obj && typeof obj === 'function' && !isReactClass(obj);
}